// extracted by mini-css-extract-plugin
module.exports = {"BooksSelect":"BooksSelect_BooksSelect__2NhbY","isSelected":"BooksSelect_isSelected__qkv1H","BooksSelect__Placeholder":"BooksSelect_BooksSelect__Placeholder__3TRMI"};